"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var selectWeatherShowOption_1 = require("../actions/selectWeatherShowOption");
var selectWeatherUnitOption_1 = require("../actions/selectWeatherUnitOption");
var store_1 = require("../store/store");
var owa_options_core_1 = require("owa-options-core");
var ChoiceGroup_1 = require("office-ui-fabric-react/lib/ChoiceGroup");
var owa_calendar_configuration_1 = require("owa-calendar-configuration");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var WeatherFull = /** @class */ (function (_super) {
    tslib_1.__extends(WeatherFull, _super);
    function WeatherFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onWeatherShowChange = function (ev, option) {
            selectWeatherShowOption_1.default(parseInt(option.key));
        };
        _this.onWeatherUnitChange = function (ev, option) {
            selectWeatherUnitOption_1.default(parseInt(option.key));
        };
        return _this;
    }
    WeatherFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, calendarConfiguration = _a.calendarConfiguration;
        if (!calendarConfiguration) {
            return null;
        }
        var isWeatherEnabled = owa_options_core_1.getFallbackValueIfNull(optionStore.weatherEnabled, calendarConfiguration.WeatherEnabled);
        var weatherUnit = owa_options_core_1.getFallbackValueIfNull(optionStore.weatherUnit, calendarConfiguration.WeatherUnit
            ? calendarConfiguration.WeatherUnit
            : 2 /* Fahrenheit */);
        return (React.createElement("div", null,
            React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: "" + isWeatherEnabled, label: owa_options_strings_1.default.options_weather_toggleLabel, options: [
                    {
                        key: 2 /* Enabled */.toString(),
                        text: owa_options_strings_1.default.options_weather_enabled,
                    },
                    {
                        key: 1 /* Disabled */.toString(),
                        text: owa_options_strings_1.default.options_weather_disabled,
                    },
                ], onChange: this.onWeatherShowChange }),
            React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: "" + weatherUnit, label: owa_options_strings_1.default.options_weather_unitLabel, options: [
                    {
                        key: 2 /* Fahrenheit */.toString(),
                        text: owa_options_strings_1.default.options_weather_fahrenheit,
                    },
                    {
                        key: 1 /* Celsius */.toString(),
                        text: owa_options_strings_1.default.options_weather_celsius,
                    },
                ], onChange: this.onWeatherUnitChange })));
    };
    WeatherFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            calendarConfiguration: function () { return owa_calendar_configuration_1.getCalendarConfiguration(); },
        })
    ], WeatherFull);
    return WeatherFull;
}(React.Component));
exports.default = WeatherFull;
//# sourceMappingURL=WeatherFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-weather-option/lib/components/WeatherFull.js
// module id = 5255
// module chunks = 2